import { ChangeEvent, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { Input, Modal } from 'antd';

import { yupResolver } from '@hookform/resolvers/yup';
import markerSvg from 'assets/images/marker.svg';

import { schema } from './schema';
import styles from './styles.module.css';

type PlacePredictions = { predictions: { place_id: string; description: string }[] };

type LocaleModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  handleSelect: (value: string) => void;
};

const LocaleModal = ({ open, setOpen, handleSelect }: LocaleModalProps) => {
  const { control, setValue, getFieldState } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange'
  });

  const [localeSuggestions, setLocaleSuggestions] = useState<{ id: string; name: string }[]>([]);

  const handleSearchLocale = (event: ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;

    const hasErrors = getFieldState('locale').error;

    if (window.google?.maps?.places && input.length > 2 && !hasErrors) {
      const service = new window.google.maps.places.AutocompleteService();
      service
        .getPlacePredictions({
          input,
          language: 'pt-BR',
          types: ['country', 'administrative_area_level_1', 'administrative_area_level_2']
        })
        .then(({ predictions }: PlacePredictions) => {
          setLocaleSuggestions(predictions.slice(0, 4).map(item => ({ id: item.place_id, name: item.description })));
        });
    }
  };

  const handleClose = () => {
    setLocaleSuggestions([]);
    setValue('locale', null);
    setOpen(false);
  };

  return (
    <Modal title='Localização' open={open} onCancel={handleClose} afterClose={handleClose} footer={null}>
      <Controller
        name='locale'
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <Input
              {...field}
              id='locale-input'
              placeholder='Onde?'
              onChange={e => {
                field.onChange(e);
                handleSearchLocale(e);
              }}
              style={{ margin: '8px 0' }}
              status={error ? 'error' : ''}
            />
            <p className={styles.error}>{error?.message}</p>
          </>
        )}
      />
      <div style={{ height: '230px' }}>
        {!localeSuggestions.length && (
          <>
            {['Qualquer lugar', 'São Paulo', 'Rio de Janeiro', 'Belo Horizonte'].map(locale => (
              <LocaleSuggestion name={locale} onClick={handleSelect} key={locale} />
            ))}
          </>
        )}
        {!!localeSuggestions.length &&
          localeSuggestions.map(item => <LocaleSuggestion name={item.name} onClick={handleSelect} key={item.id} />)}
      </div>
    </Modal>
  );
};

const LocaleSuggestion = ({ name, onClick }: { name: string; onClick: (value: string) => void }) => {
  return (
    <span className={styles.localeSpan} onClick={() => onClick(name)}>
      <img src={markerSvg} alt='marker icon' />
      <p className={styles.localeText}>{name}</p>
    </span>
  );
};

export default LocaleModal;
